<template>
    <ui-report title="Sent Estimates and Quotes" subtitle="Review the list of quotes and estimates sent out to people within a time period." width="max-w-3xl lg:max-w-screen-2xl" :initial-filters="initialFilters">
        <template #additional-filters="{ filters }">
            <ui-select-searchable
                label="Filter by estimator..."
                v-model="filters.estimator"
                :search="searchEstimators"
                class="md:w-64"
            ></ui-select-searchable>
        </template>
        <template #default="{ filters }">
            <reports-sent-estimates-stat
                :value="formatTotal(estimateSum)"
                :label="`Estimates Total (${estimateCount})`"
                icon="far fa-file-chart-line"
                class="lg:col-span-4"
            ></reports-sent-estimates-stat>
            <reports-sent-estimates-stat
                :value="formatTotal(quoteSum)"
                :label="`Quotes Total (${quoteCount})`"
                icon="far fa-file-chart-line"
                class="lg:col-span-4"
            ></reports-sent-estimates-stat>
            <reports-sent-estimates-stat
                :value="formatTotal(estimateSum + quoteSum)"
                :label="`Grand Total (${estimateCount + quoteCount})`"
                icon="far fa-sigma"
                class="lg:col-span-4"
            ></reports-sent-estimates-stat>
            <reports-sent-estimates-estimates :filters="filters" :parse-report="parseReport" @update:count="estimateCount = $event" @update:sum="estimateSum = $event"></reports-sent-estimates-estimates>
            <reports-sent-estimates-quotes :filters="filters" :parse-report="parseReport" @update:count="quoteCount = $event" @update:sum="quoteSum = $event"></reports-sent-estimates-quotes>
        </template>
    </ui-report>
</template>

<script>
import moment from 'moment'
import { flatMap } from 'lodash'
import { User } from '@models'
import { toCurrency } from '@utils'
import ReportsSentEstimatesAccidents from "./ReportsSentEstimatesEstimates";

export default {
  components: {ReportsSentEstimatesAccidents},
  data () {
        return {
            initialFilters: {
                estimator: {},
                range: 'since-monday',
            },
            estimateCount: 0,
            quoteCount: 0,
            estimateSum: 0,
            quoteSum: 0,
        }
    },
    methods: {
        async searchEstimators (query) {
          return (await User.search(query)).map(x => x.toDropdown())
        },
        parseReport (report, filters) {
            const from = moment(filters?.from)
            const to = moment(filters?.to)

            return flatMap(report, item => {
                if (item.closed_at && moment(item.opened_at).isBetween(from, to, 'days', '()')) {
                    const openedItem = item.clone()
                    openedItem.closed_at = null
                    return [openedItem, item]
                }

                return [item]
            })
        },
        formatTotal (total) {
            if (total === null) return total
            return toCurrency(total)
        },
    },
}
</script>
